import { Controller } from "@hotwired/stimulus";

// Выпадающий список с множественным выбором на <details>: summary выглядит как
// обычный select.field-input и показывает выбранное через запятую, внутри — чекбоксы.
// Используется для «Дополнительных методов» в форме навыка программы.
export default class extends Controller {
  static targets = ["summary"];
  static values = { placeholder: String };

  connect() {
    this.onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.element.open = false;
    };
    this.onKeydown = (event) => {
      if (event.key === "Escape" && this.element.open) {
        this.element.open = false;
        this.summaryTarget.focus();
      }
    };
    document.addEventListener("click", this.onDocumentClick);
    this.element.addEventListener("keydown", this.onKeydown);
    this.update();
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick);
    this.element.removeEventListener("keydown", this.onKeydown);
  }

  update() {
    const picked = [
      ...this.element.querySelectorAll("input[type=checkbox]:checked"),
    ].map((box) => box.dataset.short || box.value);
    this.summaryTarget.textContent = picked.length
      ? picked.join(", ")
      : this.placeholderValue;
    this.summaryTarget.classList.toggle("is-empty", picked.length === 0);
  }
}
